import React from 'react';
import Recommendations from './recommendations';
import TimeKeeping from './timekeeping';
import Disputes from './disputes';
import Pricing from './pricing';

const OfferConfig = ({ providerCompanyId, providerCompanyData }) => {
    

    return (
        <div className="space-y-6">
            <Pricing providerCompanyId={providerCompanyId} providerCompanyData={providerCompanyData} />
            <div className="border-t border-gray-200"></div>
            <Recommendations providerCompanyId = { providerCompanyId } providerCompanyData={providerCompanyData}  />
            <div className="border-t border-gray-200"></div>
            <TimeKeeping providerCompanyId = { providerCompanyId } providerCompanyData={providerCompanyData} />
            <div className="border-t border-gray-200"></div>
            <Disputes providerCompanyId = { providerCompanyId } providerCompanyData={providerCompanyData} />
        </div>
    );
};

export default OfferConfig;
